var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#181616;}\n\t.st1{fill:#181616;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st0",
    d: "M250,72C149.2,72,67.5,153.7,67.5,254.5c0,80.6,52.3,149,124.8,173.2c9.1,1.7,12.5-4,12.5-8.8 c0-4.4-0.2-18.7-0.2-34c-50.8,11-61.5-21.5-61.5-21.5c-8.3-21.1-20.3-26.7-20.3-26.7c-16.6-11.3,1.2-11.1,1.2-11.1 c18.3,1.3,28,18.8,28,18.8c16.3,27.9,42.7,19.8,53.1,15.2c1.6-11.8,6.4-19.8,11.6-24.4c-40.5-4.6-83.2-20.3-83.2-90.2 c0-19.9,7.1-36.2,18.8-49c-1.9-4.6-8.1-23.2,1.8-48.3c0,0,15.3-4.9,50.2,18.7c14.6-4,30.2-6.1,45.7-6.1c15.5,0.1,31.1,2.1,45.7,6.1 c34.8-23.6,50.1-18.7,50.1-18.7c9.9,25.1,3.7,43.7,1.8,48.3c11.7,12.8,18.8,29.1,18.8,49c0,70.1-42.7,85.5-83.3,90 c6.5,5.7,12.4,16.8,12.4,33.8c0,24.4-0.2,44.1-0.2,50.1c0,4.9,3.3,10.5,12.5,8.8c72.5-24.2,124.7-92.5,124.7-173.2 C432.5,153.7,350.8,72,250,72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st1",
    d: "M136.6,334c-0.4,0.9-1.8,1.2-3.1,0.6c-1.3-0.6-2.1-1.8-1.6-2.7c0.4-0.9,1.8-1.2,3.1-0.6 C136.3,331.9,137.1,333.1,136.6,334z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st1",
    d: "M144,342.3c-0.9,0.8-2.6,0.4-3.7-0.8c-1.2-1.3-1.4-3-0.5-3.8c0.9-0.8,2.5-0.4,3.7,0.8 C144.7,339.8,144.9,341.5,144,342.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st1",
    d: "M151.2,352.8c-1.1,0.8-2.9,0.1-4.1-1.6c-1.1-1.6-1.1-3.6,0-4.4c1.1-0.8,2.9-0.1,4.1,1.5 C152.4,350,152.4,352,151.2,352.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st1",
    d: "M161.1,362.9c-1,1.1-3.1,0.8-4.7-0.7c-1.6-1.5-2-3.6-1-4.7c1-1.1,3.2-0.8,4.7,0.7 C161.7,359.8,162.1,361.9,161.1,362.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st1",
    d: "M174.7,368.8c-0.4,1.4-2.5,2.1-4.6,1.5c-2.1-0.6-3.4-2.3-3-3.7c0.4-1.4,2.5-2.1,4.6-1.5 C173.7,365.7,175.1,367.4,174.7,368.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st1",
    d: "M189.6,369.9c0.1,1.5-1.7,2.8-3.9,2.8c-2.2,0.1-3.9-1.2-4-2.7c0-1.5,1.7-2.8,3.9-2.8 C187.8,367.2,189.6,368.4,189.6,369.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st1",
    d: "M203.5,367.6c0.3,1.5-1.2,3-3.4,3.4c-2.1,0.4-4.1-0.5-4.3-2c-0.3-1.5,1.3-3,3.4-3.4 C201.3,365.2,203.2,366.1,203.5,367.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.e0ee5c73fc0714da50a82dc37a93b66f.svg";
export { ForwardRef as ReactComponent };